import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import Table from "../../../../../../common/element/Table";
import Input from "../../../../../../common/element/Input/Input";
import Tabs from "../../../../../../common/element/Tabs";
import Dialog from "../../../../../../common/element/Dialog";
import BtnPrimary from "../../../../../../common/element/Buttons/btnPrimary";
import BtnLight from "../../../../../../common/element/Buttons/btnLight";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader";
import { Pagination } from "../../../../../../common/pagination";
import ReactPaginate from "react-paginate";
import {
  GetAllNotificationEmailTemplates,
  GetNotificationEmailTemplateById,
} from "../../../../../../actions/Admin";
import searchIcon from "../../../../../../assets/icons-svg/search-lg.svg";
import moment from "moment";

const sampleReplacements = {
  APP_URL: window.location.origin,
  support_email: "support@conserve.com.au",
  service_email: "service@conserve.com.au",
  first_name: "Alex",
  last_name: "Example",
  user_name: "Alex Example",
  name: "Alex Example",
  recipient: "Alex Example",
  recipient_first_name: "Alex",
  inviter_first_name: "Sarah",
  inviter_name: "Sarah Jenkins",
  inviteByUserName: "Sarah Jenkins",
  client_name: "Acme Corporation",
  client_trading_name: "Acme Corporation",
  provider_name: "Apex Services Pty Ltd",
  provider_business_name: "Apex Services Pty Ltd",
  provider_trading_name: "Apex Services Pty Ltd",
  trading_name: "Apex Services Pty Ltd",
  provider_contact_name: "Alex Example",
  provider_user_name: "Alex Example",
  abn: "12 345 678 901",
  abn_nzbn: "12 345 678 901",
  provider_id: "PRV-100234",
  organisation_id: "PRV-100234",
  worker_name: "Alex Example",
  worker_first_name: "Alex",
  worker_profile_link: "#",
  document_name: "Public Liability Insurance",
  doc_name: "Public Liability Insurance",
  expiry_date: "30 Nov 2026",
  renewal_date: "31 Dec 2026",
  next_renewal_date: "31 Dec 2026",
  name_of_compliance_checklist: "General Contractor Checklist",
  invoice_number: "INV-2026-0891",
  date: "23 Oct 2026",
  total_including_gst: "$1,250.00",
  verification_link: "#",
  continue_signup_link: "#",
  _otp: "123456",
  verify_otp_link: "#",
  password_reset_link: "#",
  invite_link: "#",
  reject_link: "#",
  accept_url: "#",
  reject_url: "#",
  accept_invite_link: "#",
  update_card_url: "#",
  failure_reason: "Card expired or declined by issuer",
  client_note: "Please provide updated certificate of currency.",
  client_rejected_note: "Please provide updated certificate of currency.",
  workers: "David Smith, Sarah Connor",
  _clientTradingNames: "Acme Corporation",
  client_names: "Acme Corporation",
  first_name: "Alex",
  login_url: "#",
  support_email: "support@conserve.com.au",
  induction_url: "#",
  app_download_link: "#",
  email_to: "alex@example.com",
  send_to_email: "alex@example.com"
};

const compileSampleString = (str) => {
  if (!str) return "";
  let rendered = str;
  Object.keys(sampleReplacements).forEach((key) => {
    const val = sampleReplacements[key];
    const regex = new RegExp(`{{${key}}}`, "g");
    rendered = rendered.replace(regex, val);
  });
  return rendered;
};

const compileSampleHtml = (html) => {
  if (!html) return "<p>No preview available</p>";
  let rendered = html;
  // Handle OTP digit boxes
  rendered = rendered.replace(
    /\{\{#each\s+_otp\}\}[\s\S]*?\{\{\/each\}\}/gi,
    `<span style="display:inline-block;border:2px solid #5786cc;width:64px;height:64px;text-align:center;line-height:60px;font-weight:700;border-radius:8px;font-size:48px;color:#5786cc;margin-right:6px;margin-bottom:8px;">1</span>` +
    `<span style="display:inline-block;border:2px solid #5786cc;width:64px;height:64px;text-align:center;line-height:60px;font-weight:700;border-radius:8px;font-size:48px;color:#5786cc;margin-right:6px;margin-bottom:8px;">2</span>` +
    `<span style="display:inline-block;border:2px solid #5786cc;width:64px;height:64px;text-align:center;line-height:60px;font-weight:700;border-radius:8px;font-size:48px;color:#5786cc;margin-right:6px;margin-bottom:8px;">3</span>` +
    `<span style="display:inline-block;border:2px solid #5786cc;width:64px;height:64px;text-align:center;line-height:60px;font-weight:700;border-radius:8px;font-size:48px;color:#5786cc;margin-right:6px;margin-bottom:8px;">4</span>`
  );
  // Handle summary tables (documents each block)
  rendered = rendered.replace(
    /\{\{#each\s+documents\}\}[\s\S]*?\{\{\/each\}\}/gi,
    `<tr style="border-bottom:1px solid #eaecf0;">
       <td class="doc-cell" style="padding:10px 8px; font-size:12px; line-height:16px; font-family:'Raleway', sans-serif; color:#344054;">Public Liability Insurance</td>
       <td class="doc-cell" style="padding:10px 8px; font-size:12px; line-height:16px; font-family:'Raleway', sans-serif; color:#344054;">Company Document</td>
       <td class="doc-cell" style="padding:10px 8px; font-size:12px; line-height:16px; font-family:'Raleway', sans-serif; color:#344054;">Acme Corporation</td>
       <td class="doc-cell" align="center" style="padding:10px 8px; font-size:12px; font-family:'Raleway', sans-serif; white-space:nowrap; color:#344054;">15 Nov 2026</td>
       <td class="doc-cell" align="center" style="padding:10px 8px; font-size:12px; font-family:'Raleway', sans-serif; white-space:nowrap;"><span style="color:#027a48; font-weight:600; font-size:11px;">EXPIRING SOON</span></td>
     </tr>
     <tr style="border-bottom:1px solid #eaecf0; background-color:#fff5f5;">
       <td class="doc-cell" style="padding:10px 8px; font-size:12px; line-height:16px; font-family:'Raleway', sans-serif; color:#d92d20; font-weight:700;">Workers Compensation Policy</td>
       <td class="doc-cell" style="padding:10px 8px; font-size:12px; line-height:16px; font-family:'Raleway', sans-serif; color:#d92d20; font-weight:700;">Company Document</td>
       <td class="doc-cell" style="padding:10px 8px; font-size:12px; line-height:16px; font-family:'Raleway', sans-serif; color:#d92d20; font-weight:700;">Acme Corporation</td>
       <td class="doc-cell" align="center" style="padding:10px 8px; font-size:12px; font-family:'Raleway', sans-serif; white-space:nowrap; color:#d92d20; font-weight:700;">20 Oct 2026</td>
       <td class="doc-cell" align="center" style="padding:10px 8px; font-size:12px; font-family:'Raleway', sans-serif; white-space:nowrap;"><span style="color:#d92d20; font-weight:700; font-size:11px;">EXPIRED</span></td>
     </tr>`
  );
  // Replace sample variable tokens
  Object.keys(sampleReplacements).forEach((key) => {
    const val = sampleReplacements[key];
    const regex = new RegExp(`{{${key}}}`, "g");
    rendered = rendered.replace(regex, val);
  });
  // Clean up any remaining block tags like {{#if ...}}, {{else}}, {{/if}}, etc.
  rendered = rendered.replace(/\{\{#[^{}]+\}\}/g, "");
  rendered = rendered.replace(/\{\{\/[^{}]+\}\}/g, "");
  rendered = rendered.replace(/\{\{\s*else[^{}]*\}\}/gi, "");
  // Clean up any remaining unresolved tags
  rendered = rendered.replace(/{{[^{}]+}}/g, "");
  // Remove spacer.gif images so they don't render broken placeholders
  rendered = rendered.replace(/<img[^>]*spacer\.gif[^>]*>/gi, "");
  // Fix invalid email hrefs like <a href="user@example.com"> without mailto:
  rendered = rendered.replace(/<a\b[^>]*href=["'](?!mailto:)[^"']+@[^"']+["'][^>]*>([\s\S]*?)<\/a>/gi, '<span style="color:#5786cc">$1</span>');
  // Fallback if footer email span is empty
  rendered = rendered.replace(/(This email was sent to\s*<span[^>]*>)\s*(<\/span>)/gi, '$1alex@example.com$2');
  return rendered;
};

const NotificationEmailList = ({ onEditTemplate }) => {
  const dispatch = useDispatch();
  const { Tr, Th, Td, THead, TBody } = Table;
  const { TabNav, TabList } = Tabs;

  const [activeTab, setActiveTab] = useState("admin");
  const [searchTerm, setSearchTerm] = useState("");
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const totalPages = Math.ceil(totalCount / limit) || 1;

  // Preview dialog state
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);

  const fetchTemplates = useCallback(
    (recipientType, search, page, pageLimit) => {
      setLoading(true);
      dispatch(
        GetAllNotificationEmailTemplates({
          recipient_type: recipientType,
          search: search || undefined,
          page,
          limit: pageLimit,
        })
      )
        .then((res) => {
          setLoading(false);
          if (res?.data) {
            setTemplates(res.data.rows || []);
            setTotalCount(res.data.count || 0);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [dispatch]
  );

  useEffect(() => {
    fetchTemplates(activeTab, searchTerm, currentPage, limit);
  }, [activeTab, searchTerm, currentPage, limit, fetchTemplates]);

  const handleTabChange = (val) => {
    setActiveTab(val);
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    const term = typeof e === "string" ? e : e?.target?.value ?? "";
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    setCurrentPage(newPage);
  };

  const handleOpenPreview = (tpl) => {
    setPreviewTemplate(tpl);
    setPreviewOpen(true);
    if (!tpl.template_html) {
      dispatch(GetNotificationEmailTemplateById(tpl.notif_email_template_id)).then((res) => {
        if (res?.data) {
          setPreviewTemplate(res.data);
        }
      });
    }
  };

  return (
    <div className="w-full">
      {/* Title */}
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Notification emails</h1>

      {/* Tabs */}
      <Tabs defaultValue="admin" variant="pill" onChange={handleTabChange} value={activeTab}>
        <div className="w-full bg-[#f4f7f9] border border-gray-100 p-1 rounded-xl mb-6">
          <TabList className="flex w-full">
            <TabNav className="flex-1 text-center py-2.5 px-3 text-sm font-medium rounded-lg cursor-pointer transition" value="admin">
              Admin notifications
            </TabNav>
            <TabNav className="flex-1 text-center py-2.5 px-3 text-sm font-medium rounded-lg cursor-pointer transition" value="client">
              Client notifications
            </TabNav>
            <TabNav className="flex-1 text-center py-2.5 px-3 text-sm font-medium rounded-lg cursor-pointer transition" value="provider">
              Provider notifications
            </TabNav>
            <TabNav className="flex-1 text-center py-2.5 px-3 text-sm font-medium rounded-lg cursor-pointer transition" value="worker">
              Worker notifications
            </TabNav>
          </TabList>
        </div>

        {/* Search */}
        <div className="mb-6 max-w-md">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Find a template</label>
          <div className="relative">
            <Input
              type="text"
              placeholder="Search by name, trigger or subject"
              value={searchTerm}
              onChange={handleSearchChange}
              inputchangehandler={handleSearchChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
            <img
              src={searchIcon}
              alt="Search"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none opacity-50"
            />
          </div>
        </div>

        {/* Table Container */}
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm mb-4">
          {loading ? (
            <div className="p-12 flex justify-center items-center">
              <ThreeDotBouncing />
            </div>
          ) : (
            <Table className="w-full text-left border-collapse">
              <THead className="bg-[#F8FAFC] border-b border-gray-200">
                <Tr>
                  <Th className="py-3.5 px-4 text-xs font-semibold text-[#344054] normal-case w-1/4">
                    Template name
                  </Th>
                  <Th className="py-3.5 px-4 text-xs font-semibold text-[#344054] normal-case w-2/5">
                    When this is sent
                  </Th>
                  <Th className="py-3.5 px-4 text-xs font-semibold text-[#344054] normal-case w-1/6">
                    Last modified
                  </Th>
                  <Th className="py-3.5 px-4 text-xs font-semibold text-[#344054] normal-case w-1/6">
                    Last modified by
                  </Th>
                  <Th className="py-3.5 px-4 text-xs font-semibold text-[#344054] normal-case text-left">
                    Actions
                  </Th>
                </Tr>
              </THead>
              <TBody className="divide-y divide-gray-100">
                {templates.length === 0 ? (
                  <Tr>
                    <Td colSpan={5} className="py-8 text-center text-gray-500 text-sm">
                      No notification email templates found.
                    </Td>
                  </Tr>
                ) : (
                  templates.map((tpl) => {
                    const modDate = tpl.updated_date || tpl.created_date;
                    const dateFormatted = modDate ? moment(modDate).format("DD MMM YYYY") : "-";
                    const timeFormatted = modDate ? moment(modDate).format("HH:mm") : "";
                    const modifierName = tpl.lastModifiedByUser?.trim() || "Conserve Team";

                    return (
                      <Tr key={tpl.notif_email_template_id} className="hover:bg-gray-50 transition-colors">
                        <Td className="py-4 px-4 text-sm font-medium text-gray-900 align-top">
                          <div className="font-semibold text-gray-900">{tpl.template_name}</div>
                          {tpl.template_subject && (
                            <div className="text-xs text-gray-500 font-normal mt-1 leading-snug line-clamp-2" title={tpl.template_subject}>
                              <span className="font-medium text-gray-600">Subject: </span>
                              {compileSampleString(tpl.template_subject)}
                            </div>
                          )}
                        </Td>
                        <Td className="py-4 px-4 text-sm text-gray-600 align-top">
                          {tpl.trigger_description}
                        </Td>
                        <Td className="py-4 px-4 text-sm text-[#475467] align-top whitespace-nowrap">
                          <div className="font-normal text-[#101828]">{dateFormatted}</div>
                          {timeFormatted && <div className="text-xs text-[#475467] mt-0.5">{timeFormatted}</div>}
                        </Td>
                        <Td className="py-4 px-4 text-sm text-gray-600 align-top whitespace-nowrap">
                          {modifierName}
                        </Td>
                        <Td className="py-4 px-4 text-sm align-top whitespace-nowrap text-left">
                          <div className="flex items-center gap-2 justify-start">
                            <button
                              type="button"
                              onClick={() => onEditTemplate(tpl.notif_email_template_id)}
                              className="px-3.5 py-1.5 text-sm font-medium text-[#344054] bg-white border border-[#D0D5DD] rounded-lg shadow-sm hover:bg-[#F9FAFB] hover:border-[#98A2B3] transition cursor-pointer"
                            >
                              Edit
                            </button>
                            <button
                              type="button"
                              onClick={() => handleOpenPreview(tpl)}
                              className="px-3.5 py-1.5 text-sm font-medium text-[#344054] bg-white border border-[#D0D5DD] rounded-lg shadow-sm hover:bg-[#F9FAFB] hover:border-[#98A2B3] transition cursor-pointer"
                            >
                              Preview
                            </button>
                          </div>
                        </Td>
                      </Tr>
                    );
                  })
                )}
              </TBody>
            </Table>
          )}
        </div>

        {/* Pagination */}
        {!loading && totalCount > 0 && (
          <div className="flex justify-between mt-3 mb-6">
            <Pagination
              totalCount={totalCount}
              pageNumber={currentPage}
              limit={limit}
              displayPage={templates?.length || 0}
              UpdatePageLimit={setLimit}
              UpdatePage={setCurrentPage}
            />
            <ReactPaginate
              className="flex justify-content-end p-2 align-items-center pagination-wrap"
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              previousLinkClassName={"prev-link"}
              nextLinkClassName={"page-link"}
              breakLinkClassName={"prev-link"}
              previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
              nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
              pageLinkClassName={"px-4 rounded-md"}
              activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
              disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
              renderOnZeroPageCount={null}
              forcePage={currentPage - 1}
            />
          </div>
        )}
      </Tabs>


      {/* Preview Dialog */}
      <Dialog
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
        width="760px"
      >
        <div className="p-6">
          <div className="border-b border-gray-200 pb-4 mb-4 pr-10">
            <h3 className="text-lg font-semibold text-gray-900">
              {previewTemplate?.template_name || "Email Preview"}
            </h3>
            <p className="text-xs text-gray-500 mt-1 break-words">
              <strong>Subject:</strong> {compileSampleString(previewTemplate?.template_subject)}
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 max-h-[550px] overflow-y-auto">
            <div
              className="bg-white p-6 rounded shadow-sm"
              dangerouslySetInnerHTML={{
                __html: compileSampleHtml(previewTemplate?.template_html),
              }}
            />
          </div>

          <div className="mt-5 flex justify-end gap-3">
            <BtnLight onClick={() => setPreviewOpen(false)}>Close</BtnLight>
            <BtnPrimary
              onClick={() => {
                setPreviewOpen(false);
                if (previewTemplate) onEditTemplate(previewTemplate.notif_email_template_id);
              }}
            >
              Edit this template
            </BtnPrimary>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default NotificationEmailList;
